'use client';

import Link from 'next/link';
import React from 'react';

const CTA = () => {
    return (
        <section className="py-20 bg-black">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 className="text-4xl font-bold text-white mb-4">
                    Ready to Dominate AI Search?
                </h2>
                <p className="text-xl text-gray-300 mb-8">
                    Startups and indie makers are already using SEOZast to rank faster and cheaper — you can too.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link href="/register">
                        <span className="bg-emerald-500 text-white px-8 py-4 rounded-lg hover:bg-emerald-600 transition-colors font-semibold text-lg cursor-pointer inline-block">
                            Try for Free
                        </span>
                    </Link>
                    <Link href="/#pricing">
                        <span className="border border-gray-600 text-gray-300 px-8 py-4 rounded-lg hover:bg-gray-800 transition-colors font-semibold text-lg cursor-pointer inline-block">
                            View Pricing
                        </span>
                    </Link>
                </div>
                <p className="text-md text-gray-400 italic mt-8">
                    “More people now search with AI than Google” —{' '}
                    <a
                        href="https://www.forbes.com/advisor/business/ai-statistics/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-emerald-500 hover:underline"
                    >
                        Forbes
                    </a>
                </p>
                <div className="mt-8 flex justify-center items-center gap-4 ">
                    {/* <a
                        href="https://www.uneed.best/tool/seozast"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src="https://www.uneed.best/POTD1A.png"
                            alt="SEOZast Uneed Product of the Day Badge"
                            className="w-24 sm:w-28 h-auto shadow-lg rounded-md"
                        />
                    </a> */}
                    {/* Uneed Badge */}
                    <a
                        href="https://www.uneed.best/tool/seozast"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src="https://www.uneed.best/POTD1A.png"
                            alt="SEOZast Uneed Product of the Day"
                            className="h-8 sm:h-10 w-auto rounded"
                        />
                    </a>

                    {/* Fazier Badge */}
                    <a
                        href="https://fazier.com/launches/seozast"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-shrink-0"
                    >
                        <img
                            src="https://fazier.com/api/v1/public/badges/embed_image.svg?launch_id=4694&badge_type=weekly&theme=light"
                            alt="Fazier First Place Badge"
                            className="h-8 sm:h-10 w-auto"
                        />
                    </a>

                    {/* TinyLaunch Badge */}
                    <a
                        href="https://tinylaun.ch"
                        target="_blank"
                        rel="noopener"
                        className="flex-shrink-0"
                    >
                        <img
                            src="https://tinylaun.ch/tinylaunch_badge_2.svg"
                            alt="TinyLaunch Badge"
                            className="h-10 sm:h-12 w-auto"
                        />
                    </a>
                    <a
                        href="https://twelve.tools"
                        target="_blank"
                        rel="noopener"
                        className="flex-shrink-0"
                    >
                        <img
                            src="https://twelve.tools/badge0-dark.svg"
                            alt="Featured on Twelve Tools"
                            className="h-8 sm:h-10 w-auto"
                        />
                    </a>
                </div>
            </div>
        </section>
    );
};

export default CTA;

